import {
  call,
  put, select,
  takeEvery,
} from 'redux-saga/effects';
import API from 'library/constants/api';
import request from 'library/helpers/request';
import {
  showErrorNotification, showSuccessNotification,
} from 'store/shared/actions';
import { FILTER_KEYS, TYPE } from 'store/browse-items/fixtures';
import * as constants from './constants';
import * as actions from './actions';
import {
  getBrowseItems, resetBrowseItemsActions, resetBrowseItems as resetBrowseItemsAction, setBrowseItemsFilters,
} from '../browse-items/actions';
import { getSets } from '../sets/actions';
import {
  getWishlistItems,
  resetWishlistItems as resetWishlistItemsAction,
  resetWishlistItemsActions,
} from '../wishlist-items/actions';
import { getBrowseItemsFilters } from '../browse-items/selectors';

function* getSet(action) {
  try {
    const { data } = yield call(request, `${API.BROWSE_SETS}/${action.payload.id}`, 'GET');

    yield put(actions.getSetSuccess(data));
  } catch (e) {
    yield put(actions.getSetError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* getSetWatcher() {
  yield takeEvery(constants.GET_SET, getSet);
}

function* deleteSet(action) {
  const {
    id,
    shouldUpdate = true,
  } = action.payload;

  try {
    const { data } = yield call(request, `${API.BROWSE_SETS}/${id}`, 'DELETE');

    yield put(actions.deleteSetSuccess(data));

    if (shouldUpdate) {
      yield put(getBrowseItems());
    }
    yield put(showSuccessNotification({ message: 'Set successfully deleted' }));
  } catch (e) {
    yield put(actions.deleteSetError(e));
    yield put(showErrorNotification({ message: 'Failed to fetch data, please try later.' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* deleteSetWatcher() {
  yield takeEvery(constants.DELETE_SET, deleteSet);
}

function* createSet(action) {
  const {
    data,
    shouldUpdateBrowseItems = true,
  } = action.payload;
  try {
    yield call(request, `${API.BROWSE_SETS}`, 'POST', { data });
    yield put(showSuccessNotification({ message: 'New set successfully created' }));
    // yield put(resetBrowseItemsActions());
    if(shouldUpdateBrowseItems) {
      const filters = yield select(getBrowseItemsFilters);

      yield put(resetBrowseItemsAction());
      yield put(setBrowseItemsFilters({
        ...filters,
        [FILTER_KEYS.TYPE]: TYPE.SET,
      }));
      yield put(getBrowseItems());
    }
    yield put(actions.createSetSuccess());
    yield put(getSets());
  } catch (e) {
    yield put(actions.createSetError(e));
    yield put(showErrorNotification({ message: 'Oops :(' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* createSetWatcher() {
  yield takeEvery(constants.SET_CREATE, createSet);
}

function* batchAddToSet(action) {
  const {
    ids: item_ids = [],
    id,
    messages,
    resetBrowseItems = false,
    resetSet = false,
    resetWishlistItems: resetWishlistItemsTrigger = false,
  } = action.payload;
  try {
    if (item_ids.length) {
      yield call(request, `${API.BROWSE_SETS}/bulk/add/${id}`, 'PATCH', { data: { item_ids } });
      yield put(showSuccessNotification({ message: messages.success }));
    }

    yield put(actions.batchAddToSetSuccess());

    if (resetBrowseItems) {
      yield put(resetBrowseItemsAction());
      yield put(resetBrowseItemsActions());
      yield put(getBrowseItems());
    }

    if (resetWishlistItemsTrigger) {
      yield put(resetWishlistItemsAction());
      yield put(getWishlistItems());
      yield put(resetWishlistItemsActions());
    }

    if (resetSet) {
      yield put(actions.resetSet());
      yield put(actions.getSet({ id }));
    }
  } catch (e) {
    yield put(actions.batchAddToSetError(e));
    yield put(showErrorNotification({ message: e.message }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* batchAddToSetWatcher() {
  yield takeEvery(constants.BATCH_ADD_TO_SET, batchAddToSet);
}

function* batchRemoveFromSet(action) {
  const {
    ids: item_ids = [],
    id,
    messages,
    resetBrowseItems = false,
    resetSet = false,
  } = action.payload;
  try {
    if (item_ids.length) {
      yield call(request, `${API.BROWSE_SETS}/bulk/remove/${id}`, 'PATCH', { data: { item_ids } });
      yield put(showSuccessNotification({ message: messages.success }));
    }

    yield put(actions.batchAddToSetSuccess());

    if (resetBrowseItems) {
      yield put(resetBrowseItemsAction());
      yield put(getBrowseItems());
    }

    if (resetSet) {
      yield put(actions.resetSet());
      yield put(actions.getSet({ id }));
    }
  } catch (e) {
    yield put(actions.batchAddToSetError(e));
    yield put(showErrorNotification({ message: e.message }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* batchRemoveFromSetWather() {
  yield takeEvery(constants.BATCH_REMOVE_FROM_SET, batchRemoveFromSet);
}

function* editSet(action) {
  const {
    data,
    id,
    // shouldUpdate = true
  } = action.payload;
  try {
    yield call(request, `${API.BROWSE_SETS}/${id}`, 'PATCH', { data });
    yield put(showSuccessNotification({ message: 'Set successfully updated' }));
    yield put(actions.getSet({ id }));
  } catch (e) {
    yield put(showErrorNotification({ message: 'Oops :(' }));
  }
}

// eslint-disable-next-line import/prefer-default-export
export function* editSetWatcher() {
  yield takeEvery(constants.SET_EDIT, editSet);
}
